<div *ngIf="report">

  <div [style]="styles.header.page">
    <div [style]="styles.header.text">
      <b>STYLE EXPRESSION PREFERENCE</b>
    </div>
    <div [style]="styles.header.line"></div>
  </div>

  <div [style]="styles.container_padding">

    <p [style]="styles.paragraph">
      {{
      isFacilitator
      ? 'Your most used expression is'
      : 'When you communicate, ' + (report.name || 'the participant') + ' wants you to use a'
      }}
      <span [style]="styles.highlight">{{ report.styleExpression || '...' }}</span>
      {{
      isFacilitator ? '.' : ' approach.'
      }}
    </p>

    <p [style]="styles.paragraph" [innerHTML]="html"></p>

  </div>

</div>